import { createStore, getActionIds } from '../../helpers/redux';
import Immutable from 'immutable';

import { AddRelationshipTypeMetaPropertyActions } from '../../actions/forms/addRelationshipTypeMetaProperty';
import { ProjectActions } from '../../actions/project';

const projectActions = getActionIds(ProjectActions);
const addRelationshipTypeMetaPropertyActions = getActionIds(
  AddRelationshipTypeMetaPropertyActions,
);

const initialState = Immutable.fromJS({
  form: {},
  currentRelationshipType: null,
  activeProp: null,
  submitting: false,
  notifications: {},
  propType: 'String',
});

export const addRelationshipTypeMetaPropertyForm = createStore(initialState, {
  [projectActions.resetReducers]: (state, action) => {
    return initialState;
  },

  [addRelationshipTypeMetaPropertyActions.setType]: (state, action) => {
    return state.merge({
      propType: action.propType,
    });
  },

  [addRelationshipTypeMetaPropertyActions.setActiveProperty]: (
    state,
    action,
  ) => {
    return state.merge({
      form: { relationshipTypeMetaPropName: action.prop.prop },
      currentRelationshipType: action.prop.relationshipTypeId,
      activeProp: action.prop.prop,
    });
  },

  [addRelationshipTypeMetaPropertyActions.setName]: (state, action) => {
    return state.merge({
      propName: action.propName,
    });
  },

  [addRelationshipTypeMetaPropertyActions.setValue]: (state, action) => {
    return state.merge({
      propValue: action.propValue,
    });
  },
});



// WEBPACK FOOTER //
// ./src/reducers/forms/addRelationshipTypeMetaProperty.js